// Das Video im Kopfbereich wiegt 2,8 MB und war damit rund 70 Prozent der
// Startseite - auf dem Handy lud es vor allem anderen und hat den ersten
// Eindruck verzoegert. Es haengt deshalb nur als Adresse im Markup und wird
// erst angehaengt, wenn die Seite steht. Bis dahin sieht man das Standbild.

const kopfVideos = document.querySelectorAll('video[data-fn-video]');

if (kopfVideos.length) {
    // Wer Daten sparen will oder auf einer langsamen Verbindung sitzt,
    // bekommt das Standbild - und keine drei Megabyte.
    const verbindung = navigator.connection;
    const sparsam = !!verbindung && (verbindung.saveData === true || /(^|-)2g$/.test(verbindung.effectiveType || ''));

    const anhaengen = (video) => {
        const adresse = video.getAttribute('data-fn-video');

        if (!adresse || video.src) {
            return;
        }

        video.src = adresse;
        video.load();

        // Das autoplay-Attribut greift, sobald eine Quelle da ist. Der
        // zusaetzliche Aufruf ist nur die Rueckfalloption fuer Browser, die
        // das nach einem spaeteren src nicht mehr von selbst tun.
        const versuch = video.play();

        if (versuch && versuch.catch) {
            versuch.catch(() => {});
        }
    };

    if (!sparsam) {
        // Nach dem Laden der Seite, damit Bilder und Schrift zuerst da sind
        const starten = () => kopfVideos.forEach(anhaengen);

        if (document.readyState === 'complete') {
            window.setTimeout(starten, 200);
        } else {
            window.addEventListener('load', () => window.setTimeout(starten, 200), { once: true });
        }

        // Wer die Seite in einem Hintergrund-Tab oeffnet, bekommt vom Browser
        // kein autoplay. Ohne diesen zweiten Anlauf bliebe das Standbild
        // stehen, auch wenn er spaeter hinschaut.
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState !== 'visible') {
                return;
            }

            kopfVideos.forEach((video) => {
                anhaengen(video);

                if (video.paused) {
                    const versuch = video.play();

                    if (versuch && versuch.catch) {
                        versuch.catch(() => {});
                    }
                }
            });
        });
    }
}
